import { render, staticRenderFns } from "./settings-templates-documents.vue?vue&type=template&id=21913f38&"
import script from "./settings-templates-documents.ts?vue&type=script&lang=ts&"
export * from "./settings-templates-documents.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports